// src/pages/designer/DesignerOrders.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { getOrders } from "../../lib/db";
import { TableCard, Table, Badge, Spinner, fmt$, fmtDate, orderStatusForBadge } from "../../components/UI";

export default function DesignerOrders() {
  const pagePad = "var(--page-pad-x)";
  const { profile } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  useEffect(() => {
    if (!profile?.uid) return undefined;
    let cancelled = false;
    setLoadError("");
    setLoading(true);
    getOrders(profile.uid)
      .then((o) => {
        if (!cancelled) setOrders(o);
      })
      .catch((err) => {
        console.error(err);
        if (!cancelled) setLoadError("Could not load orders. Check your connection or try again.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [profile?.uid]);

  const cols = [
    { key:"num",    label:"Sales Order #" },
    { key:"projectId", label:"Project ID" },
    { key:"attach", label:"File" },
    { key:"client", label:"Client / Project" },
    { key:"desc",   label:"Description" },
    { key:"amount", label:"Amount" },
    { key:"comm",   label:"Commission" },
    { key:"status", label:"Status" },
    { key:"date",   label:"Date" },
  ];

  const rows = orders.map(o => ({
    num:    <span style={{fontFamily:"'Cormorant Garamond',serif",fontWeight:400}}>{o.orderNumber || o.id.slice(0,8).toUpperCase()}</span>,
    projectId: o.projectId || "—",
    attach: o.attachmentUrl ? (
      <a href={o.attachmentUrl} target="_blank" rel="noopener noreferrer" style={{ color: "var(--gold)", fontWeight: 500 }}>
        {o.attachmentName || "Open"}
      </a>
    ) : "—",
    client: o.clientName,
    desc:   <span style={{fontSize:12,color:"var(--mid)"}}>{o.description || "—"}</span>,
    amount: fmt$(o.amount),
    comm:   <span style={{color:"var(--gold)"}}>{fmt$(o.commission)}</span>,
    status: <Badge label={orderStatusForBadge(o.status)} />,
    date:   fmtDate(o.createdAt),
  }));

  return (
    <div>
      <div style={{ padding:`28px ${pagePad} 0` }}>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:300 }}>My Orders</h1>
        <p style={{ fontSize:13, color:"var(--mid)", marginTop:4 }}>Orders you've referred to David Meyer Showroom</p>
      </div>
      <div style={{ padding:`var(--page-pad-y) ${pagePad} 32px` }}>
        <TableCard title={`Order History (${loading ? "…" : orders.length})`}>
          {loading ? (
            <Spinner />
          ) : loadError ? (
            <div style={{ padding: "36px 24px", fontSize: 14, color: "var(--mid)", textAlign: "center" }}>{loadError}</div>
          ) : (
            <Table cols={cols} rows={rows} emptyMsg="No orders yet — submit a referral to get started!" />
          )}
        </TableCard>
      </div>
    </div>
  );
}
